const e={"&":`&amp;`,"<":`&lt;`,">":`&gt;`,'"':`&quot;`,"'":`&#39;`},t=/[&<>"']/g,n=n=>n&&n.replace(t,t=>e[t]);export{n as escapeHtmlEntities};
//# sourceMappingURL=escape-html-entities.js.map